import Editor from '@/components/Editor'
import { mapState, mapActions } from 'vuex'
export const configCommon = {
  computed: {
    ...mapState({
      isPC: state => state.isPC,
      isWeixin: state => state.isWeixin,
      video: state => state.video,
      isElectron: state => state.isElectron,
      robotList: state => state.robotList,
      user: state => state.user,
      cloud: state => state.cloud
    })
  },
  components: {
    Editor
  },
  methods: {
    ...mapActions(['updateRobotList', 'updateUser', 'changeLoadingStatus']),
    // 贵重来宾欢迎语句添加
    shoWDialogBuy(key, name, videoKey, descType = '') {
      this.$emit('shoWDialogBuy', key, name, videoKey, descType)
    },
    showFunctionalRenewal(bool) {
      //展示功能续费弹窗
      this.$emit('showFunctionalRenewal', bool)
    },
    resetDefault(title, dataName) {
      this.$emit('resetDefault', title, dataName)
    },
    toggleEnable(value, name) {
      this.$emit('toggleEnable', value, name)
    },
    checkEmpty(list, index) {
      this.$emit('checkEmpty', list, index)
    }, // 列表被清空时
    removeTag(list, index) {
      this.$emit('removeTag', list, index)
    },
    addTag(list, evt) {
      this.$emit('addTag', list, evt)
    }
  }
}
